import dayjs from "dayjs";

// Helpers for "From / To" date filters.

// The range after the user picks a new From. A From later than the current To would
// make the range invalid, so To is cleared and has to be chosen again.
export const rangeAfterFromChange = ({ to }, nextFrom) => ({
  from: nextFrom,
  to: isEndBeforeStart(nextFrom, to) ? "" : to,
});

// The range after the user picks a new To, or null when that To is before From (the
// change is rejected and the range stays as it was).
export const rangeAfterToChange = ({ from }, nextTo) =>
  isEndBeforeStart(from, nextTo) ? null : { from, to: nextTo };

// True when both dates are set and `to` falls on an earlier day than `from`.
export const isEndBeforeStart = (from, to) => {
  if (!from || !to) return false;
  const start = dayjs(from);
  const end = dayjs(to);
  return start.isValid() && end.isValid() && end.isBefore(start, "day");
};
